import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { fetchProductSchemaAndConfig } from '../configurations/fetchProductSchemaAndConfig'
import { getHeaders, getUrlWithVersion } from '../../../api/api'

export const uploadMultipleConfigs = createAsyncThunk<
    void,
    { guid: string; formData: FormData },
    ThunkConfig<string>
>('productsSlice/uploadMultipleConfigs', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, formData } = args

    try {
        const response = await api.post(
            getUrlWithVersion(`/products/${guid}/configuration_files`),
            formData,
            {
                headers: getHeaders({
                    'Content-Type': 'multipart/formdata',
                }),
            }
        )

        if (response.status === 200) {
            throwSuccessMessage('Config files uploaded')
            dispatch(fetchProductSchemaAndConfig({ guid, forceUpdate: true }))
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to upload config files')
    }
})
